module.exports = __webpack_public_path__ + "img/magento.cff8513a.webp";